import React, { useState } from 'react';
import { Stack, Box, TextField, TextareaAutosize, Button, FormLabel, FormHelperText, CircularProgress } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import { styled } from '@mui/material/styles';
import * as yup from 'yup';
import { useNavigate } from "react-router-dom";
import routes from '../routers/routes';


let schema = yup.object().shape({
  mensaje: yup.string().min(3).required(),
  asunto: yup.string().min(3).required(),
  correo: yup.string().email().required(),
  nombre: yup.string().min(3).required(),
});

const A = styled('a')({
  color: 'white',
  display: 'inline-flex',
  alignItems: 'center',
});

const CustomTextareaAutosize = styled(TextareaAutosize, { shouldForwardProp: (prop) => prop !== 'error' })(({ error, theme }) => ({
  flexGrow: 1,
  resize: 'unset',
  fontSize: '14px',
  backgroundColor: 'white',
  outline: 0,
  borderRadius: '4px',
  padding: '16.5px 14px',
  ...(error && {borderColor: '#d32f2f !important'}),
  '&:hover': {
    borderColor: 'primary.main',
  },
  '&:focus': {
    border: `solid 2px ${theme.palette.primary.main}`,
  },
}));

const Contacto = (props) => {
  const [errors, setErrors] = useState({ nombre: false, asunto: false, correo: false, mensaje: false });
  const [sent, setSent] = useState(false);
  const [saving, setSaving] = useState(false);
  let navigate = useNavigate();

  const handleOnSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!saving) {
      setSaving(true);
      const formData = new FormData(document.querySelector('form'))
      const data = {};
      const errors = { nombre: false, asunto: false, correo: false, mensaje: false };
      for (var pair of formData.entries()) {
        data[pair[0]] = pair[1];
      }
      schema.validate(data).then((result) => {
        // console.log('result', result);
        fetch('https://s7zvyr41ph.execute-api.us-east-1.amazonaws.com/default/Lideres_En_Movimiento_Contacto', {
              mode: 'no-cors',
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data)
        }).then(function (response) {
          setSent(true);
          setSaving(false);
        })
        .catch(function (error) {
          setSaving(false);
          console.log(error);
        });
        setErrors(errors);
      }).catch((err) => {
        errors[err.path] = true;
        setErrors(errors);
        setSaving(false);
      });
    }
  };

  const handleGoHome = () => navigate(routes.root);

  return (
    <Stack
      alignItems="center"
      sx={{
        py: 5,
        px: '5%',
        flexGrow: 1,
        width: '100%',
        boxSizing: 'border-box',
        background: '#1592bd',
        background: '-webkit-linear-gradient(to right, #2aa399, #1592bd)',
        background: 'linear-gradient(148deg, #2aa399, #1592bd)',
      }}
    >
      <Stack sx={{ width: '100%' }}>
        <Box sx={{ typography: 'h4', fontWeight: 'bold', color: 'white' }}>Contáctanos</Box>
        <Stack sx={{ color: 'white', textAlign: 'left', mb: 2 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <span>WhatsApp: </span>
            <A target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send/?phone=5554724817">
              <WhatsAppIcon sx={{ mr: 1 }} /><span>5554724817</span>
            </A>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <span>Correo Electrónico: </span>
            <A href="mailto:contacto@lideresenmovimiento.mx">
              <EmailIcon sx={{ mr: 1 }} /><span>contacto@lideresenmovimiento.mx</span>
            </A>
          </Stack>
        </Stack>
      </Stack>
      {sent ? (
        <Stack component="form" onSubmit={handleOnSubmit} sx={{ maxWidth: '1200px', width: '100%', color: 'white' }} spacing={2} action={0}>
          <Stack>Su mensaje ha sido enviado!</Stack>
          <Button onClick={handleGoHome} variant="contained">Regresar a la página de inicio</Button>
        </Stack>
      ) : (
        <Stack component="form" onSubmit={handleOnSubmit} sx={{ maxWidth: '1200px', width: '100%' }} spacing={2} action={0}>

          <FormLabel required={true} error={errors['nombre']} component="legend" sx={{ alignSelf: 'flex-start', color: 'white' }}>Nombre</FormLabel>
          <TextField
            name="nombre"
            variant="outlined"
            sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { backgroundColor: 'white' } }}
            error={errors['nombre']}
            helperText={errors['nombre'] && "Debe tener más de 3 caracteres"}
          />
          <FormLabel required={true} error={errors['correo']} component="legend" sx={{ alignSelf: 'flex-start', color: 'white' }}>Correo</FormLabel>
          <TextField
            name="correo"
            variant="outlined"
            sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { backgroundColor: 'white' } }}
            error={errors['correo']}
            helperText={errors['correo'] && "Debe ser un correo electrónico válido"}
          />
          <FormLabel required={true} error={errors['asunto']} component="legend" sx={{ alignSelf: 'flex-start', color: 'white' }}>Asunto</FormLabel>
          <TextField
            name="asunto"
            variant="outlined"
            sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { backgroundColor: 'white' } }}
            error={errors['asunto']}
            helperText={errors['asunto'] && "Debe tener más de 3 caracteres"}
          />
          <FormLabel required={true} error={errors['mensaje']} component="legend" sx={{ alignSelf: 'flex-start', color: 'white' }}>
            Mensaje
          </FormLabel>
          <CustomTextareaAutosize
            name="mensaje"
            variant="outlined"
            minRows={3}
          />
          {errors['mensaje'] && (
            <FormHelperText error={errors['mensaje']}>Debe tener más de 3 caracteres</FormHelperText>
          )}
          <Button type="submit" variant="contained">{saving ? <CircularProgress sx={{ color: 'white' }}/> : 'Enviar'}</Button>
        </Stack>
      )}
    </Stack>
  );
};

export default Contacto;
